export default __webpack_public_path__ + "static/media/backend.7827841d.jpg";